import { FC, useState } from 'react';
import Icon from '~/components/icon';
import CommonData from '~/data/strapi/types/single-types/common-data';

import BurgerMenuContext from './context';
import Menu from './menu';
import styles from './styles.module.css';

interface Props {
  commonData: CommonData;
  onCallClick: () => void;
}

const BurgerMenu: FC<Props> = ({ commonData, onCallClick }) => {
  const [show, setShow] = useState<boolean>(false);

  const toggleMenu = () => {
    setShow(!show);
  };
  const closeMenu = () => setShow(false);

  return (
    <BurgerMenuContext.Provider value={{ closeMenu }}>
      <div className={styles.container}>
        <button onClick={toggleMenu} className={styles.button} aria-label="Открыть меню">
          {show ? <Icon name="burger-close" /> : <Icon name="burger" />}
        </button>

        <Menu show={show} commonData={commonData} onCallClick={onCallClick} />
      </div>
    </BurgerMenuContext.Provider>
  );
};

export default BurgerMenu;
